import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Wrapper, Link} from './FSArating.style';

export class FSArating extends PureComponent {
  render() {
    const {restaurant} = this.props;
    const rating = restaurant.foodHygieneRatingDisplayed && restaurant.foodHygieneRatingValue;
    const ratingId = restaurant.foodHygieneRatingDisplayed && restaurant.foodHygieneRatingId;
    const FSAsite = 'https://ratings.food.gov.uk/business/en-GB';
    return rating && (
      <Wrapper>
        <Link
          href={`${FSAsite}/${ratingId}`}
          target="_blank"
        >
          <img
            src={`https://api1-ratings.food.gov.uk/images/scores/large/fhrs_${rating}_en-gb.JPG`}
            alt={`${restaurant.name} - FSA rating - ${rating} stars`}
          />
        </Link>
      </Wrapper>
    );
  }
}

FSArating.propTypes = {
  restaurant: PropTypes.object.isRequired
};

export default FSArating;



// WEBPACK FOOTER //
// ./components/FSArating/FSArating.js